import * as d3 from 'd3';
import tooltip from 'd3-tip';

import {
  GetChartData,
  getNoDataFoundLabel,
  renderDrillDownChartOnField
} from '../../../utils/graph_service';
import { groupBarChartUtility } from './groupBarChartUtility';
import { getTipInfo, wrapText } from '../../../utils/helper';
import _ from 'lodash';
import store from '../../../store/appStore';
import * as LocalCacheActionType from '../../../store/localCache/actionTypes';
function numberWithCommas (num) {
  return (num || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function BarChartUtility (
  chartConfig,
  divId,
  onDrillDown,
  drillDownConfig,
  level,
  allowDrillDown
) {
  const margin = { top: 20, right: 20, bottom: 100, left: 30 };
  let width = 300 - margin.left - margin.right;
  let height = 250 - margin.top - margin.bottom;

  const node = document.getElementById(divId);
  if (!chartConfig.data || !node) return;

  if (node !== null) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }
  const windowWidth = node.offsetWidth;
  if (windowWidth > width) {
    width = windowWidth - margin.left - margin.right;
  }

  const windowHeight = node.offsetHeight;
  if (windowHeight > height) {
    height = (windowHeight > width ? width : windowHeight) - margin.top - margin.bottom;
  }
  RenderBarChart(drillDownConfig);

  function RenderBarChart (drillDownConfig) {
    // console.log("here", drillDownConfig.isDrillDown, drillDownConfig.key);
    if (drillDownConfig.isDrillDown && allowDrillDown === true && chartConfig.configuration.drillDownConfig) {
      const dirllDownColumnsConfig = { ...chartConfig.configuration };
      if (chartConfig.configuration.drillDownConfig) {
        renderDrillDownChartOnField(chartConfig, drillDownConfig, level, divId, onDrillDown, allowDrillDown);
      } else {
        const filters = [];
        if (chartConfig.configuration.isRepeated === true) {
          filters.push({
            key: chartConfig.configuration.autoGenerate.key,
            values: [
              drillDownConfig.config.find((x) => x.level === level + 1).key
            ]
          });
          dirllDownColumnsConfig.autoGenerate.filters = filters;
        } else {
          dirllDownColumnsConfig.columns = [
            chartConfig.configuration.columns.find(
              (x) =>
                x.name ===
                [drillDownConfig.config.find((x) => x.level === level + 1).key]
            )
          ];
        }
        const resData = GetChartData(
          chartConfig.rawData,
          dirllDownColumnsConfig,
          chartConfig.startDate,
          chartConfig.endDate,
          drillDownConfig.type
        );
        if (drillDownConfig.currentLevel === level + 1) {
          drillDownConfig.isDrillDown = false;
        }
        // console.log("here resData", resData);
        // console.log("here dirllDownColumnsConfig", dirllDownColumnsConfig);
        const config = {
          startDate: chartConfig.startDate,
          endDate: chartConfig.endDate,
          configuration: dirllDownColumnsConfig,
          rawData: chartConfig.rawData,
          data: resData.data,
          yAxisLabel: chartConfig.configuration.yAxisLabel ?? 'count',
          type: 'GroupBarChart',
          keys: resData.barKeys,
          colors: resData.barColors,
          accessor: resData.chartAccessor.mainAccessor
        };
        groupBarChartUtility(
          config,
          divId,
          onDrillDown,
          drillDownConfig,
          level + 1,
          allowDrillDown
        );
      }
    } else {
      store.dispatch({
        type: LocalCacheActionType.SET_CACHE_DATA,
        payload: { key: chartConfig.widgetId, data: chartConfig?.drillDowndata }
      });
      store.dispatch({
        type: LocalCacheActionType.SET_CACHE_DATA,
        payload: { key: chartConfig.widgetId + 'drillconfig', data: drillDownConfig }
      });
      return generateBarChart(
        chartConfig.data,
        chartConfig.keys,
        chartConfig.colors,
        divId,
        chartConfig.yAxisLabel,
        chartConfig,
        drillDownConfig
      );
    }
  }

  function generateBarChart (data, keys, colors, divId, yAxisLabel, chartConfig, drillDownConfig) {
    let totalCount = 0;
    let legendCount = 0;
    const key = 'attributeValue';
    // const linekey = (chartConfig?.configuration?.autoGenerate?.dataColumn || [])[1]?.key || 'attributeValue';
    localStorage.removeItem(chartConfig.widgetId);
    store.dispatch({
      type: LocalCacheActionType.SET_CACHE_DATA,
      payload: { key: chartConfig.widgetId, data: chartConfig?.drillDowndata }
    });
    store.dispatch({
      type: LocalCacheActionType.SET_CACHE_DATA,
      payload: { key: chartConfig.widgetId + 'drillconfig', data: drillDownConfig }
    });
    localStorage.setItem(chartConfig.widgetId, JSON.stringify(chartConfig?.drillDowndata));
    localStorage.removeItem(chartConfig.widgetId + 'drillconfig');
    localStorage.setItem(chartConfig.widgetId + 'drillconfig', JSON.stringify(drillDownConfig));
    // localStorage.removeItem(chartConfig.widgetId+'rawData');
    // localStorage.setItem(chartConfig.widgetId +'rawData', JSON.stringify(chartConfig.rawData));
    (data || []).forEach(function (d) {
      totalCount += Math.round(parseFloat(d[key]));
      legendCount += 1;
      return d;
    });
    if (totalCount <= 0 && drillDownConfig.currentLevel <= 1) {
      const node = document.getElementById(divId);
      node.innerHTML = 'No data available for ' + chartConfig.startDate + ' to ' + chartConfig.endDate;
      node.classList.add('no-data');
      return;
    }
    if (chartConfig.configuration.orderBy !== undefined && chartConfig.configuration.orderBy !== '') {
      const orderBy = key;
      data = _.orderBy(data || [], [data => ((data[orderBy]) !== null && data[orderBy] !== undefined && isNaN(data[orderBy]) !== false)
        ? (data[orderBy]).toString().toLowerCase()
        : data[orderBy]], [chartConfig.configuration.orderBy]);
    }
    const y = d3.scaleLinear().rangeRound([height, 0]);

    if (legendCount > 20) {
      width = (20 * legendCount) - margin.left - margin.right;
    }

    const x = d3
      .scaleBand()
      .range([0, width])
      .padding(0.5);

    const svgContainer = d3.select('#' + divId).append('svg');

    const svg = legendCount > 20
      ? svgContainer
        .append('g')
        .attr('width', (width) + 'px')
        .attr(
          'transform',
          'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top) + ')'
        )
      : svgContainer
        .append('g')
        .attr(
          'transform',
          'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top) + ')'
        );

    x.domain(
      data.map(function (d) {
        return d.attributeName;
      })
    );
    y.domain([
      0,
      d3.max(data, function (d) {
        return parseFloat(d[key] || 0);
      })
    ]);

    totalCount = 0;
    data.forEach(function (d) {
      totalCount += parseInt(d[key]);
      return d;
    });

    const tipInfo1 = tooltip()
      .attr('class', 'd3-tip tooltip' + divId)
      .html(function (d) {
        let htmltext = 'Drill down by=> </br>';
        (d || []).forEach((x) => {
          if (x.key !== undefined) {
            htmltext = htmltext + (x.keyTitle ? x.keyTitle + ': ' : '') + x.key + '</br>';
          }
        });
        return htmltext;
      });
    svg.call(tipInfo1);

    if (totalCount === 0) {
      svgContainer.attr('height', height + 20);
      svgContainer.attr('width', width + 10);
      getNoDataFoundLabel(
        chartConfig.startDate + ' to ' + chartConfig.endDate,
        svg,
        height / 2,
        ((width + margin.left + margin.right) / 2 - 50)
      );

      if (drillDownConfig.currentLevel > 1) {
        let type = 'Month';
        if ((chartConfig.widgetconfig || {}).isForPerformance === true) {
          level = drillDownConfig.currentLevel;
          type = 'YTD';
          allowDrillDown = true;
        }
        svg.call(tipInfo1);
        svg
          .append('g')
          .attr(
            'transform',
            'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top - 10) + ')'
          )
          .attr('width', '30px')
          .attr('height', '30px')
          .on('mouseover', function (d, i) {
            console.log('drillDownConfig.drillDownFilter', drillDownConfig.drillDownFilter);
            tipInfo1.show(drillDownConfig.config, this);
          })
          .on('mouseout', function (d) {
            tipInfo1.hide();
          })
          .append('svg')
          .style('fill', '#07406d')
          .style('cursor', 'pointer')
          .attr('y', -30)
          .attr('x', width - 30)
          .style('font-size', '0.768rem')
          .append('path')
          .attr(
            'd',
            'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'
          );

        const avgn = svg
          .append('svg')
          .style('fill', '#07406d')
          .style('cursor', 'pointer')
          .attr('y', -30)
          .attr('x', -30)
          .style('font-size', '0.768rem')
          .append('a')
          .on('click', function (d) {
            // alert("jj");
            onDrillDown(false, drillDownConfig.key, type, '', level);
          });

        avgn.append('rect')
          .attr('width', '20px')
          .attr('height', '20px')
          .style('fill', 'transparent')
          .attr(
            'transform',
            'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top - 10) + ')'
          )
          .attr(
            'd',
            'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
          );

        avgn.append('path')
          .attr(
            'd',
            'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
          )
        ;
      }
    } else {
      chartConfig.configuration.hideXAxisLabel = true;
      const xAxisText = svg
        .append('g')
        .attr('class', 'x axis' + (chartConfig.configuration.hideXAxisLabel === true ? ' hideline' : ''))
        .attr('transform', 'translate(0,' + height + ')')
        .call(d3.axisBottom(x).ticks(5).tickSize(5));
      xAxisText.selectAll('text')
        .call(wrapText, x.bandwidth(), chartConfig.configuration.hideXAxisLabel)
        .style('text-anchor', 'revert')
        .style('font-family', 'roboto')
        .style('font-weight', '500')
        .style('font-size', '0.668rem')
        .attr('transform', 'rotate(0)');

      svg
        .append('g')
        .attr('class', 'y axis')
        .style('font-family', 'roboto')
        .style('font-weight', '500')
        .style('font-size', '0.668rem')
        .call(d3.axisLeft(y).ticks(5));

      document.querySelectorAll('.tooltip' + divId).forEach(function (a) {
        a.remove();
      });

      function getTooltipTemplate (d) {
        if (chartConfig.configuration.tooltipTemplate !== undefined) {
          let tip = chartConfig.configuration.tooltipTemplate;
          Object.keys(d).forEach(x => {
            tip = tip?.replace('#' + x + '#', d[x] || '');
          });
          return tip;
        }
        return '';
      }

      const tip = tooltip()
        .attr('class', 'd3-tip tooltip' + divId)
        .html(function (d) {
          return d.attributeName + '<br/> <span class="tipspan">' + (chartConfig.configuration?.yAxisLabel ?? 'Count') + ': ' + numberWithCommas(d[key]).toString() + getTooltipTemplate(d) + '</span><br/>' + getTipInfo(d, chartConfig.configuration?.yAxisLabel !== 'Employee Count', chartConfig);
        });
      const tipInfo = tooltip()
        .attr('class', 'd3-tip tooltip' + divId)
        .html(function (d) {
          let htmltext = 'Drill down by=> </br>';
          (d || []).forEach((x) => {
            if (x.key !== undefined) {
              htmltext = htmltext + (x.keyTitle ? x.keyTitle + ': ' : '') + x.key + '</br>';
            }
          });
          return htmltext;
        });
      svg.call(tip);
      svg.call(tipInfo);

      if (chartConfig?.widgetType === 'BarLineChart') {
        const xScale = d3.scalePoint().range([20, width - 90]);
        const yScale = d3.scaleLinear().range([height, 20]);

        // Scale the range of the data

        xScale
          .domain(data.map(function (d) {
            return d.attributeName;
          }));

        yScale
          .domain([0, d3.max(data, function (d) {
            return d[linekey];
          })]);

        const valuelineData = d3
          .line()
          .curve(d3.curveMonotoneX)
          .x(function (d) {
            return xScale(d.attributeName);
          })
          .y(function (d) {
            return yScale(d[linekey]);
          });

        const linetip = tooltip()
          .attr('class', 'd3-tip tooltip' + divId)
          .html(function (d) {
            return d[linekey];
          });
        svg.call(linetip);
        svg
          .append('path')
          .attr('clip-path', 'url(#clip)')
          .data([data])
          .style('fill', 'none')
          .style('stroke', colors[0])
          .style('cursor', 'pointer')
          .style('stroke-width', '1.5px')
          .style('z-index', '9999')
          .attr('class', 'line')
          .attr('d', valuelineData);

        svg
          .selectAll('line-circle')
          .data(data)
          .enter()
          .append('circle')
          .style('z-index', '999999')
          .attr('r', 5.5)
          .style('fill', colors[0])
          .style('stroke', colors[0])
          // .style("pointer-events", "all")
          .style('cursor', 'pointer')
          .style('z-index', '999999')
          .attr('cx', function (d) {
            return xScale(d.attributeName);
          })
          .attr('cy', function (d) {
            return yScale(d[linekey]);
          })
          .attr('class', 'line-circle')
          .on('mouseover', function (d, i) {
            linetip.show(d, this);
          })
          .on('mouseout', function (d) {
            linetip.hide();
          });

        // getYAxisLabel(yAxisLabel, svg, -55, 0 - height / 2 - 10, -90);
      }
      svg
        .selectAll('bar')
        .data(data)
        .enter().append('g')
        .attr('class', 'bar')
        .append('rect')
        .attr('text-anchor', 'middle')
        .style('cursor', 'pointer')
        .style('fill', function (d, i) {
          return colors[i];
        })
        .attr('x', function (d) {
          return x(d.attributeName);
        })
        .attr('width', x.bandwidth())
        .attr('y', function (d) {
          return y(parseFloat(d[key]).toFixed(2));
        })
        .attr('height', function (d) {
          return height - y(parseFloat(d[key]).toFixed(2));
        })
        .on('mouseover', function (d, i) {
          tip.show(d, this);

          d3.selectAll('rect')
            .transition()
            .duration(200)
            .style('opacity', 0.5);
          d3.select(this)
            .transition()
            .duration(200)
            .style('opacity', 1)
            .style('stroke-width', '2.5px');
        })
        .on('mouseout', function (d) {
          tip.hide();
          d3.selectAll('rect')
            .transition()
            .duration(200)
            .style('opacity', 1)
            .style('stroke-width', '1.5px');
        })
        .on('click', function (d) {
          // alert("jj");
          tip.hide();
          onDrillDown(
            true,
            d.attributeName,
            chartConfig.accessor,
            '',
            level + 1,
            d.seriesItem,
            (d.data || {}).data,
            (d || {}).keyTitle,
            (d || {}).drillDownKey
          );
        });

      svg.selectAll('text.bar')
        .data(data)
        .enter().append('text')
        .attr('class', 'bar')
        .attr('text-anchor', 'middle')
        .attr('x', function (d) { return x(d.attributeName) + x.bandwidth() / 2; })
        .attr('y', function (d) { return y(d[key]) - 2; })
        .text(function (d) { return numberWithCommas(d[key]); })
        .style('font-family', 'roboto')
        .style('font-weight', '500')
        .style('font-size', '10px');

      if (drillDownConfig.currentLevel > 1) {
        let type = 'Month';
        if ((chartConfig.widgetconfig || {}).isForPerformance === true) {
          level = drillDownConfig.currentLevel;
          type = 'YTD';
          allowDrillDown = true;
        }
        svgContainer
          .append('g')
          .attr(
            'transform',
            'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top - 10) + ')'
          )
          .attr('width', '30px')
          .attr('height', '30px')
          .on('mouseover', function (d, i) {
            console.log('drillDownConfig.drillDownFilter', drillDownConfig.drillDownFilter, data);
            tipInfo.show(drillDownConfig.config, this);
          })
          .on('mouseout', function (d) {
            tipInfo.hide();
          })
          .append('svg')
          .style('fill', '#07406d')
          .style('cursor', 'pointer')
          .attr('y', -30)
          .attr('x', width - 35)
          .style('font-size', '0.768rem')
          .append('path')
          .attr(
            'd',
            'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'
          );

        svgContainer
          .data(data)
          .append('text')
          .attr(
            'transform',
            'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top - 10) + ')'
          )
          .attr('y', -15)
          .attr('x', 10)
          .attr('height', 30)
          .attr('width', 170)
          .style('font-family', 'roboto')
          .style('font-weight', '500')
          .style('font-size', '0.768rem')
          .style('color', '#07406d')
          .text(function (d) {
            return 'By ' + (d.keyTitle || '');
          });

        const ag = svgContainer
          .append('svg')

          .attr(
            'transform',
            'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top - 10) + ')'
          )
          .style('fill', '#07406d')
          .style('cursor', 'pointer')
          .attr('y', -30)
          .attr('x', -30)
          .style('font-size', '0.768rem')
          .append('a')
          .attr('width', '24px')
          .attr('display', 'block')
          .on('click', function (d) {
            // alert("jj");
            onDrillDown(false, drillDownConfig.key, type, '', level);
          });

        ag.append('rect')
          .attr('width', '20px')
          .attr('height', '20px')
          .style('fill', 'transparent')
          .attr(
            'transform',
            'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top - 10) + ')'
          )
          .attr(
            'd',
            'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
          );
        ag.append('path')
          .attr(
            'transform',
            'translate(' + (margin.left + margin.top) + ',' + (margin.top + margin.top - 10) + ')'
          )
          .attr(
            'd',
            'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
          );
      }
      const svgSize = svg.node().getBBox();
      width = (legendCount > 20 ? legendCount * 20 : svgSize.width) + margin.left;
      let legendline = svgSize.height + ((drillDownConfig.currentLevel > 1) ? 30 : 50);
      let currentX = margin.left;
      const legend = svgContainer
        .append('g')
        .attr('class', 'legend-container')
        .attr('width', width);

      legend
        .selectAll('g')
        .data(data)
        .enter()
        .append('g')
        .each(function (d, i) {
          const g = d3.select(this);
          let y = legendline;
          const rect = g
            .append('rect')
            .attr('y', y)
            .attr('x', currentX)
            .attr('width', 10)
            .attr('height', 10)
            .attr(
              'class',
              d.attributeName?.replace(/[^a-zA-Z0-9]/g, '') + ' legend'
            )
            .style('fill', colors[i]);

          const size = rect.node().getBBox();
          currentX += size.width + 10;
          if (currentX > width) {
            currentX = margin.left;
            legendline += 20;
            y = legendline;
            rect.attr('x', currentX).attr('y', y);
            currentX += size.width + 10;
          }
          const recText = g
            .append('text')
            .attr('y', y + 10)
            .attr('x', currentX)
            .attr('height', 30)
            .attr('width', 170)
            .attr(
              'class',
              d.attributeName?.replace(/[^a-zA-Z0-9]/g, '') + ' legend'
            )
            .style('fill', colors[i])
            .style('font-family', 'roboto')
            .style('font-weight', '500')
            .style('font-size', '0.668rem')
            .style('cursor', 'pointer')
            .text(function (d) {
              // return ((d?.keyTitle?.toLowerCase() === 'marketname' ||
              //   d?.keyTitle?.toLowerCase() === 'market') && !((d.attributeName || '').indexOf('tream') > 0)
              //   ? (d.attributeName || '').split('-')[0]
              //   : d.attributeName || '') + ' (' + numberWithCommas(d.attributeValue) + ')';
              return (d.attributeName || '') + ' (' + numberWithCommas(d[key]) + ')';
            }).on('click', function (d) {
              // alert("jj");
              tip.hide();
              onDrillDown(
                true,
                d.attributeName,
                chartConfig.accessor,
                '',
                level + 1,
                d.seriesItem,
                (d.data || {}).data,
                (d || {}).keyTitle
              );
            });
          const recTextsize = recText.node().getBBox();
          currentX += recTextsize.width + 20;
          if (currentX > width) {
            currentX = margin.left;
            legendline += 20;
            y = legendline;
            rect.attr('x', currentX).attr('y', y);
            currentX += size.width + 10;
            recText.attr('x', currentX).attr('y', y + 10);
            currentX += recTextsize.width + 20;
          }
        });

      const legendSize = legend.node().getBBox();
      svgContainer.attr('height', svgSize.height + legendSize.height + 10 + 50);
      svgContainer.attr('width', (legendCount > 20 ? legendCount * 20 : svgSize.width) + 10);
      svgContainer.attr('viewBox', [10, 5, (legendCount > 20 ? legendCount * 20 : svgSize.width) + 15, svgSize.height + legendSize.height + 50]);
    }
  }
}
export { BarChartUtility };
